import { render, staticRenderFns } from "./AddUserToGroupModal.vue?vue&type=template&id=54d597a5&"
import script from "./AddUserToGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddUserToGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports